function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBowieBoltSpelled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1009.1 319.5",
    style: {
      enableBackground: "new 0 0 1009.1 319.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3685C6"
    },
    points: "98.3,17.8 111.7,16 30.9,192.7 159.4,153.9 34.9,317.4 54.5,232 67.7,184.6 0,215.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0A0808"
    },
    points: "102.7,17.2 109.4,16.4 19.8,202.5 167.6,143.3 37.8,313.2 58.9,227.8 71.3,183.7 3.9,213.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D02527"
    },
    d: "M173.9,66.3l-38.3-1.7L185,53.1L229.4,0L107.1,16.7L10.6,210.5L77,181.1l-11.9,41.2l-23.3,85.5 l156-204l-88.8,40L173.9,66.3z M120,31.6l66.5-9.6l-19,20.9l-57.1,7.9L120,31.6z M101.4,84.6l42.3-7.3l-28.7,31l-35.2,10.7 L101.4,84.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3685C6"
    },
    points: "284,19.9 300.9,17.7 255.4,164.7 343.8,130.2 220.5,319.5 240.1,234.1 253.3,186.7  185.6,217.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0A0808"
    },
    points: "288.3,19.3 299,18 248.6,172.7 349.9,124 223.5,315.3 244.6,229.9 256.9,185.8 189.5,215.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D02527"
    },
    d: "M415.1,2.1L292.7,18.8l-96.5,193.8l66.4-29.4l-11.9,41.2l-23.3,85.5l156-204l-88.8,40L415.1,2.1z  M306.9,43.6l48.2-7.2l-42.5,56.9l-34.3,5.8L306.9,43.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3685C6"
    },
    points: "479.8,19.9 505.1,16.6 422.3,171 539.6,130.2 416.3,319.5 435.9,234.1 449.1,186.7  381.4,217.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0A0808"
    },
    points: "484.1,19.3 494.9,18 439,173.6 545.7,124 419.3,315.3 440.4,229.9 452.7,185.8 385.3,215.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D02527"
    },
    points: "610.9,2.1 555.5,9.7 486.1,127.5 532.3,12.8 532.2,12.8 455.8,130.7 511.6,15.6 488.5,18.8  392,212.6 458.4,183.2 446.5,224.4 423.2,309.9 579.2,105.9 490.4,146  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3685C6"
    },
    points: "764.3,48.5 662.3,57.7 662.3,57.7 582.7,217.4 650.3,186.7 637.1,234.1 617.6,319.5  740.8,130.2 666,164.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3685C6"
    },
    points: "781.7,27.9 801.5,4.5 681,19.9 669.7,42.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0A0808"
    },
    points: "787.6,27.2 807.6,4.5 685.3,19.3 673.9,42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0A0808"
    },
    points: "769.1,48.1 666.2,57.4 586.5,215.7 654,185.8 641.6,229.9 620.5,315.3 746.9,124  658.1,173.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D02527"
    },
    points: "791.6,26.6 791.6,26.6 812.1,2.1 689.7,18.8 678.5,41.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D02527"
    },
    points: "781.8,41.4 670.7,56.9 593.3,212.6 659.6,183.2 647.7,224.4 624.4,309.9 780.4,105.9  691.6,146  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3685C6"
    },
    points: "878,19.5 899.7,16.8 863,164.3 858.8,261.4 814.6,319.1 834.2,233.7 847.4,186.3 779.7,217  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0A0808"
    },
    points: "882.4,18.9 899.7,16.8 855.2,173.2 873.6,241.3 817.5,314.9 838.6,229.5 851,185.4  783.6,215.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D02527"
    },
    points: "886.8,18.4 1009.1,1.7 967.2,51.8 916.9,58.4 911.6,74.5 963.5,64.5 935.4,105.7  896.3,121.7 888.6,145.6 977.4,105.5 821.4,309.5 844.8,224 856.7,182.8 790.3,212.2  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowieBoltSpelled);
export default __webpack_public_path__ + "static/media/bowie-bolt-spelled.9b1deaf4.svg";
export { ForwardRef as ReactComponent };